var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicableFalse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 15 15",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#13ACC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M5.321 10.382l-2.343-4.03v4.03H1.779V4.553H3.01l2.311 3.966V4.553H6.52v5.829H5.321zM12.538 10.322l-.384-1.175H9.972l-.392 1.175H8.356l2.07-5.829h1.328l2.015 5.829h-1.231zm-1.472-4.453l-.759 2.279h1.519l-.76-2.279z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicableFalse);
export default __webpack_public_path__ + "static/media/applicable_false.d72adae7bd30620d09d092e1c3530026.svg";
export { ForwardRef as ReactComponent };